import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Pencil} from "lucide-react";
import { useNavigate,useLocation } from 'react-router-dom';
import { api_url } from '../config/config';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import warn from "../images/warning.png";
const UserProfile = () => {
    const [userData, setUserData] = useState({
        username: '',
        email: '',
        role: '',
        mobile_number: '',
        address: '',
    });


 const { id } = useParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
const [designation, setDesignation] = useState("");
  const [roll, setRoll] = useState("");
  const [mobilenumber, setMobilenumber] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const navigate = useNavigate();
   const location = useLocation();
  const { user } = location?.state || {};
  const [showModal, setShowModal] = useState(false);
  const [modalStep, setModalStep] = useState(1); 
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]); 
  const otp = otpDigits.join("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otpToken, setOtpToken] = useState("");
  const [apiError, setApiError] = useState("");
  const [apiLoading, setApiLoading] = useState(false);
  const [editName, setEditName] = useState("");
  const [editMobile, setEditMobile] = useState("");

     const fetchProfileData = async () => {
        const response = await fetch(`${api_url}/admin/profile-user`, {
          method: 'GET',
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
          },
        });
            
        const { data } = await response.json();
        if (data) {
         setName(data.name);
         setEmail(data.email);
         setMobilenumber(data.mobile_number);
         setDesignation(data.designation);
         setRoll(data.role);
         if (data.role) {
           localStorage.setItem('roles', data.role);
         }
        }
    
      };
     
      useEffect(() => {
    
        fetchProfileData();
      }, [id]);

const updateProfileData=async()=>{
  try{
    const res= await fetch(`${api_url}/admin-user/profile-user`, {
      method:'PATCH',
      headers:{
        'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
      },
      body: JSON.stringify({
        name: editName,
        mobile_number: editMobile,
      }), 
    });
    const data = await res.json();
    if(res.ok){
      toast.success("Profile updated successfully!");
    } else {
      const errorData = await res.json();
      toast.error(errorData.message || "Failed to update profile");
    }
  }catch(e){
    console.error("Error updating profile:", e);
    toast.error("Failed to update profile. Please try again.");
  }
  }


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUserData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
      setEditName(name);
      setEditMobile(mobilenumber);
    }, [name, mobilenumber]);

    const handleEditClick = () => {
      setIsEditing(true);
    };

    const handleSaveEdit = async () => {
      
      if (!editName.trim()) {
        alert("Name cannot be empty");
        return;
      }
      if (!/^[A-Za-z\s]+$/.test(editName)) {
        alert("Name should contain only alphabets and spaces");
        return;
      }
    
      if (!/^[0-9]{10}$/.test(editMobile)) {
        alert("Mobile number must be exactly 10 digits");
        return;
      }
      await updateProfileData();
      setIsEditing(false);
      setName(editName);
      setMobilenumber(editMobile);
    };    
    const handleCancelEdit = () => {
      setIsEditing(false);
      setEditName(name);
      setEditMobile(mobilenumber);
    };
    const handleResetPassword = () => {
      setShowModal(true);
      setModalStep(1);
      setOtpDigits(["", "", "", "", "", ""]);
      setNewPassword("");
      setConfirmPassword("");
    };
    const handleContinueCaution = async () => {
      setApiError("");
      setApiLoading(true);
      try {
        const res = await fetch(`${api_url}/reset-password/send-otp`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
                 'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
          },
          body: JSON.stringify({}),
        });
        const data = await res.json();
        if (res.ok && data?.otpToken) {
          setOtpToken(data.otpToken);
          setModalStep(2);
        } else {
          setApiError(data?.message || "Failed to initiate password reset.");
        }
      } catch (err) {
        setApiError("Network error. Try again.");
      } finally {
        setApiLoading(false);
      }
    };
    const handleCancelCaution = () => {
      setShowModal(false);
    };
    const handleOtpInputChange = (e, idx) => {
      const value = e.target.value.replace(/[^0-9]/g, "");
      if (value.length > 1) return; 
      const newDigits = [...otpDigits];
      newDigits[idx] = value;
      setOtpDigits(newDigits);
     
      if (value && idx < 5) {
        const nextInput = document.getElementById(`otp-input-${idx + 1}`);
        if (nextInput) nextInput.focus();
      }
    };
    const handleOtpKeyDown = (e, idx) => {
      if (e.key === "Backspace" && !otpDigits[idx] && idx > 0) {
        const prevInput = document.getElementById(`otp-input-${idx - 1}`);
        if (prevInput) prevInput.focus();
      }
    };
    const handleOtpSave = async () => {
      setApiError("");
      setApiLoading(true);
      try {
        const res = await fetch(`${api_url}/reset-password/verify-otp`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
                'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
          },
          body: JSON.stringify({
            otpToken,
            otp: otpDigits.join("")
          })
        });
        const data = await res.json();
        if (res.ok) {
          setModalStep(3);
        } else {
          setApiError(data?.message || "Invalid OTP.");
        }
      } catch (err) {
        setApiError("Network error. Try again.");
      } finally {
        setApiLoading(false);
      }
    };
    const handlePasswordSave = async () => {
      setApiError("");
      setApiLoading(true);
      try {
        const res = await fetch(`${api_url}/reset-password`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
             'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
          },
          body: JSON.stringify({
            otpToken,
            password: newPassword,
            confirmPassword: confirmPassword
          })
        });
        const data = await res.json();
        if (res.ok) {
          setShowModal(false);
          toast.success('Password reset successful!');
        } else {
          setApiError(data?.message || "Failed to reset password.");
        }
      } catch (err) {
        setApiError("Network error. Try again.");
      } finally {
        setApiLoading(false);
      }
    };
    const handleCloseModal = () => {
      setShowModal(false);
    };

    return (
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow mt-8 space-y-6 relative">
           <ToastContainer />
        <h2 className="text-4xl font-semibold text-gray-800 mb-6 text-center">Profile Details</h2>
      
        {!isEditing && (
          <button
            className="absolute top-8 right-8 text-gray-500 hover:text-yellow-600"
            title="Edit Profile"
            onClick={handleEditClick}
          >
            
             <Pencil size={20} />
          </button>
        )}
       
        {isEditing && (
          <div className="absolute top-8 right-8 flex gap-2">
            <button className="bg-green-600 text-white px-3 py-1 rounded" onClick={handleSaveEdit}>Save</button>
            <button className="bg-gray-300 text-gray-700 px-3 py-1 rounded" onClick={handleCancelEdit}>Cancel</button>
          </div>
        )}
        <div className="mb-6 space-y-6">
        
          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-x-12">
            <label htmlFor="name" className="w-80 font-medium text-gray-600">Name :</label>
            {isEditing ? (
              <input
                type="text"
                className="border px-2 py-1 rounded w-64"
                value={editName}
                onChange={e => {
                  const value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); 
                  setEditName(value);
                }}
              />
            ) : (
              <p className="text-gray-800">{name}</p>
            )}
          </div>

         
          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-x-12">
            <label htmlFor="email" className="w-80 font-medium text-gray-600">Email :</label>
            <input
              type="text"
              className="border px-2 py-1 rounded w-64 bg-gray-100 text-gray-800"
              value={email}
              readOnly
              disabled
            />
          </div>

        
          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-x-12">
            <label htmlFor="mobile_number" className="w-80 font-medium text-gray-600">Mobile Number :</label>
            {isEditing ? (
              <input
                type="text"
                className="border px-2 py-1 rounded w-64"
                value={editMobile}
                 onChange={e => {
                  const value = e.target.value.replace(/[^0-9]/g, "");
                  if (value.length <= 10) {
                    setEditMobile(value);
                  }
                }}
              />
            ) : (
              <p className="text-gray-800">{mobilenumber}</p>
            )}
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-x-12">
            <label htmlFor="designation" className="w-80 font-medium text-gray-600">Designation :</label>
            <input
              type="text"
              className="border px-2 py-1 rounded w-64 bg-gray-100 text-gray-800"
              value={designation || 'N/A'}
              readOnly
              disabled
            />
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-x-12">
            <label htmlFor="role" className="w-80 font-medium text-gray-600">Role :</label>
            <input
              type="text"
              className="border px-2 py-1 rounded w-64 bg-gray-100 text-gray-800"
              value={roll}
              readOnly
              disabled
            />
          </div>
        </div>
     
        <div className="flex justify-end mt-6">
          <button
            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded shadow"
            onClick={handleResetPassword}
          >
            Reset Password
          </button>
        </div>

  
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-8 relative">
              <button className="absolute top-2 right-2 w-6 h-6 text-gray-500 hover:text-gray-700" onClick={handleCloseModal}>&times;</button>
          
              {modalStep === 1 && (
                <div className="text-center">
                  <div className="flex flex-col items-center justify-center mb-4">
                 <img src={warn} alt="Warning" className="w-16 h-16 mb-2" />
                    <h3 className="text-md font-semibold text-yellow-900">Are you sure you want to reset the password?</h3>
                  </div>
                  {apiError && <div className="text-red-600 mb-2">{apiError}</div>}
                  <div className="flex justify-center gap-4 mt-6">
                  <button className="bg-gray-300 text-gray-700 px-3 py-2 rounded" onClick={handleCancelCaution} disabled={apiLoading}>Cancel</button>
                    <button className="bg-green-600 text-white px-3 py-2 rounded" onClick={handleContinueCaution} disabled={apiLoading}>{apiLoading ? "Processing..." : "Continue"}</button>
                
                  </div>
                </div>
              )} 
          
              {modalStep === 2 && (
                <div>
                  <h3 className="text-lg font-semibold mb-4">Please confirm the OTP below.</h3>
                  <div className="flex justify-center gap-3 mb-6">
                    {otpDigits.map((digit, idx) => (
                      <input
                        key={idx}
                        id={`otp-input-${idx}`}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        className="w-14 h-14 text-2xl text-center border border-gray-300 rounded focus:outline-none focus:border-green-600"
                        value={digit}
                        onChange={e => handleOtpInputChange(e, idx)}
                        onKeyDown={e => handleOtpKeyDown(e, idx)}
                      />
                    ))}
                  </div>
                  <button
                    className="bg-green-600 text-white px-4 py-2 rounded w-full disabled:bg-gray-200 disabled:text-gray-400"
                    onClick={handleOtpSave}
                    disabled={otpDigits.some(d => d === "")}
                  >
                    CONFIRM
                  </button>
                </div>
              )}
          
              {modalStep === 3 && (
                <div>
                  <h3 className="text-lg font-semibold mb-4">Reset Password</h3>
                  <label className="block mb-2 text-gray-600">New Password</label>
                  <input
                    type="password"
                    className="border px-2 py-1 rounded w-full mb-3"
                    placeholder="Enter the new password"
                    value={newPassword}
                    onChange={e => setNewPassword(e.target.value)}
                    disabled={apiLoading}
                  />
                  <label className="block mb-2 text-gray-600">Confirm Password</label>
                  <input
                    type="password"
                    className="border px-2 py-1 rounded w-full mb-4"
                    placeholder="Confirm your new password"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                    disabled={apiLoading}
                  />
                  {apiError && <div className="text-red-600 mb-2">{apiError}</div>}
                  <button
                    className="bg-green-600 text-white px-4 py-2 rounded w-full disabled:bg-gray-200 disabled:text-gray-400"
                    onClick={handlePasswordSave}
                    disabled={apiLoading || !newPassword || !confirmPassword}
                  >
                    {apiLoading ? "Saving..." : "Save"}
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
};

export default UserProfile;
